import axiosInstance from "./axiosInstance";

export const getActiveQuestions = async () => {
  // Adjust endpoint as needed
  const response = await axiosInstance.get("/questions/question-bank/active");
  // response.data.data.sort((a, b) => a.QuestionId - b.QuestionId);
  return response.data.data;
};
